export default "__VITE_ASSET__rAjdjNpo__"